import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import FaBookmark from 'react-icons/fa/bookmark'
import API from '../api'

import { SubscriptionPolicy } from 'pobble-components/dist/subscriptions'

@autobind
class WorkBookmark extends Component {
  constructor (props) {
    super(props)
  }

  toggleBookmark () {
    return (!this.props.work.bookmarked_by_me
      ? API.post(`/v3/works/${this.props.work.id}/bookmark`)
      : API.delete(`/v3/works/${this.props.work.id}/remove_bookmark`))
      .then(() => this.props.work.onBookmark(!this.props.work.bookmarked_by_me))
  }

  redirectToSignIn () {
    window.location = '/auth'
  }

  render () {
    var bookmarked = this.props.work && this.props.work.bookmarked_by_me ? 'workStats__action' : 'workStats__action--done'
    return (
      <SubscriptionPolicy policy={sp => sp.bookmarks}>
        {bookmarksSp => !this.props.user.student_type && bookmarksSp.restricted ? (
          <button className={'btn btn-primary btn-disabled'} onClick={bookmarksSp.showDialog}>
            <FaBookmark/> <span>Bookmark</span>
          </button>
        ) : (
          <button className={'workStats__action workStats__action--text btn btn-small btn-default btn-press ' + bookmarked} onClick={this.props.user.id ? this.toggleBookmark : this.redirectToSignIn}>
            <FaBookmark/> <span>Bookmark{this.props.work.bookmarked_by_me ? 'ed' : ''}</span>
          </button>
        )}
      </SubscriptionPolicy>
    )
  }
}

export default WorkBookmark

WorkBookmark.propTypes = {
  work: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkBookmark.js